/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["appearance", "isOpen", "testId", "text", "triggerRef"];
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
/* eslint-disable @atlaskit/design-system/use-tokens-typography */

import { useCallback, useEffect, useMemo, useState } from 'react';
import { cx } from '@compiled/react';
import ChevronDownIcon from '@atlaskit/icon/core/migration/chevron-down';
import Lozenge from '@atlaskit/lozenge';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  chevronDown: "_18u012x7 _1e0c1txw",
  lozengeContainer: "_kkk2n7od _2rkoiti9 _1dqonqa1 _189ee4h9 _1h6d1j28 _bfhk1j28 _1e0c1txw _4cvr1h6o _4t3i7vkz",
  lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1p6i"
};
var triggerLozengeStyles = null;
var triggerButtonStyles = null;
var LozengeActionTrigger = function LozengeActionTrigger(_ref) {
  var appearance = _ref.appearance,
    isOpen = _ref.isOpen,
    testId = _ref.testId,
    text = _ref.text,
    triggerRef = _ref.triggerRef,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovering = _useState2[0],
    setIsHovering = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isPressing = _useState4[0],
    setIsPressing = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    lozengeBackgroundColor = _useState6[0],
    setLozengeBackgroundColor = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    lozengeForegroundColor = _useState8[0],
    setLozengeForegroundColor = _useState8[1];
  var onMouseEnter = useCallback(function () {
    return setIsHovering(true);
  }, []);
  var onMouseLeave = useCallback(function () {
    return setIsHovering(false);
  }, []);
  var onMouseOrKeyDown = useCallback(function () {
    return setIsPressing(true);
  }, []);
  var onMouseOrKeyUp = useCallback(function () {
    return setIsPressing(false);
  }, []);
  useEffect(function () {
    if (isPressing) {
      setLozengeBackgroundColor("var(--ds-background-selected-pressed, #85B8FF)");
      setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
    } else if (isOpen) {
      if (isHovering) {
        setLozengeBackgroundColor("var(--ds-background-selected-hovered, #CCE0FF)");
      } else {
        setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FF)");
      }
      setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
    } else {
      setLozengeBackgroundColor(undefined);
      setLozengeForegroundColor(undefined);
    }
  }, [isPressing, isOpen, isHovering]);
  var lozenge = useMemo(function () {
    return /*#__PURE__*/React.createElement(Box, {
      xcss: cx(styles.lozengeContainer, (isOpen || isPressing) && styles.lozengeContainerSelected),
      as: "span"
    }, /*#__PURE__*/React.createElement(Lozenge, {
      appearance: appearance,
      isBold: fg('platform-component-visual-refresh') ? true : isHovering
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
      ,
      style: {
        backgroundColor: lozengeBackgroundColor,
        color: lozengeForegroundColor
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: ax(["_4cvr1h6o _1e0c1txw"])
    }, /*#__PURE__*/React.createElement("span", null, text), /*#__PURE__*/React.createElement(Box, {
      as: "span",
      xcss: styles.chevronDown
    }, /*#__PURE__*/React.createElement(ChevronDownIcon, {
      color: "currentColor",
      label: "options",
      LEGACY_size: "medium",
      LEGACY_margin: "-4px -8px -4px -7px",
      size: "small"
    })))));
  }, [appearance, isHovering, isPressing, text, isOpen, lozengeBackgroundColor, lozengeForegroundColor]);
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button"
  }, props, {
    "data-action-open": isOpen,
    "data-testid": "".concat(testId, "--trigger"),
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onMouseDown: onMouseOrKeyDown,
    onMouseUp: onMouseOrKeyUp,
    onKeyDown: onMouseOrKeyDown,
    onKeyUp: onMouseOrKeyUp,
    ref: triggerRef,
    className: ax(["_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d1j28 _bfhk1j28 _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejjo89b _1u6lo89b _6ssho89b"]),
    style: {
      "--_sq39bb": ix("0 0 0 2px ".concat("var(--ds-border-focused, #388BFF)"))
    }
  }), lozenge);
};
export default LozengeActionTrigger;